var baseUrl = "/";

require.config({
    baseUrl: baseUrl,
    paths: {
        NumericStringFormat: "static/legacy/0.0.13/lib/ksc-numeric-string-format/bundle",
        "komplett-pubsub": "static/legacy/0.0.13/lib/komplett-pubsub/pubsub",
        "ksc-breakpoint-notifier": "static/legacy/0.0.13/lib/ksc-breakpoint-notifier/js/main",
        "ksc-ko-extenders": "static/legacy/0.0.13/lib/ksc-ko-extenders/index",
        "ksc-alert": "static/legacy/0.0.13/lib/ksc-alert/js/main",
        "ksc-alert/ViewModel": "static/legacy/0.0.13/ib/ksc-alert/js/main",
        knockout: "static/legacy/0.0.13/JScript/Shims/knockout-shim",
        querystring: "static/legacy/0.0.13/JScript/Shims/querystring-shim",
        dataLayer: "static/legacy/0.0.13/JScript/Shims/datalayer-shim",
    },
    urlArgs: "",
});